/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import {
    object, func, number,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CloseIcon from '@material-ui/icons/Close';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

const styles = (theme) => ({
    editorContainer: {
        position: 'absolute',
        width: 140,
        right: 100,
        padding: 10,
        borderRadius: 4,
        border: `1px solid ${theme.palette.cgc?.shadowColor || 'rgba(0, 0, 0, 0.25)'}`,
        boxShadow: `0px 4px 4px ${theme.palette.cgc?.shadowColor || 'rgba(0, 0, 0, 0.25)'}`,
    },
    title: {
        padding: 8,
    },
    editorIcons: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    selectButton: {
        width: '100%',
        height: '30px',
    },
});
const ImageEditorControlView = ({
    classes, x, y, setX, setY, setWidth, setImage, handleShowEditor,
}) => (
    <Grid container className={classes.editorContainer} spacing={2}>
        <Grid item xs={12} className={classes.title}>
            <Typography variant={6}>Adjust Photo</Typography>
        </Grid>
        <Grid item xs={4} className={classes.editorIcons}>
            <RemoveIcon onClick={() => setWidth((20))} />
        </Grid>
        <Grid item xs={4} className={classes.editorIcons}>
            <ArrowUpwardIcon onClick={() => setY((y + 20))} />
        </Grid>
        <Grid item xs={4} className={classes.editorIcons}>
            <AddIcon onClick={() => setWidth((-20))} />
        </Grid>
        <Grid item xs={4} className={classes.editorIcons}>
            <ArrowBackIcon onClick={() => setX((x + 20))} />
        </Grid>
        <Grid item xs={4} className={classes.editorIcons}>
            <CloseIcon onClick={() => setImage('')} />
        </Grid>
        <Grid item xs={4} className={classes.editorIcons}>
            <ArrowForwardIcon onClick={() => setX((x - 20))} />
        </Grid>
        <Grid item xs={12} className={classes.editorIcons}>
            <ArrowDownwardIcon onClick={() => setY((y - 20))} />
        </Grid>
        <Grid item xs={12}>
            <Button variant="contained" color="primary" className={classes.selectButton} onClick={() => handleShowEditor(false)}>Done</Button>
        </Grid>
    </Grid>
);
ImageEditorControlView.propTypes = {
    classes: object.isRequired,
    x: number.isRequired,
    y: number.isRequired,
    setX: func.isRequired,
    setY: func.isRequired,
    setWidth: func.isRequired,
    setImage: func.isRequired,
    handleShowEditor: func.isRequired,
};
export default withStyles(styles)(ImageEditorControlView);
